// this is about organizing the vi labels in various ways
import { getMaterialColor, settings } from './store'
import { drawBox, clearCanvas, getNormalizedBox } from './canvas'
const { opacities, framesPerSpot, defaultFps } = settings.spots

export const normalizeSegments = ({ segments, duration, fps = defaultFps }) => {

  // how many entities are there? (for thos without entitiyIDS use the description)
  const sleg = segments.slice().map(f => {
    return {
      ...f,
      spot: f.entityID || f.description,
      text: f.description
    }
  })
  // if these are shot changes, we need to blow up to a single spot per segment
    .reduce((p, c ) => {
      if (c.type === 'shot') {
        c.segments.forEach((f,i) => {
          const text = c.type + ' ' + (i+1)
          p.push({
            ...c,
            spot: text,
            text,
            segments: [f]
          })
        })
      } else {
        p.push(c)
      }
      return p;
    }, [])

  // the duration is not completely accurate, and the seg times are rounded up to the nearest sec, so we need to fiddle with that and chop them back to the end of the claimed duration
  sleg.forEach(f => f.segments.forEach(s => {
    s.endTime = Math.min(s.endTime, duration)
    s.startTime = Math.min(s.startTime, duration - 0.5)
  }))


  // dedup
  const entities = sleg.map((f) => f.spot).filter((f, i, a) => a.indexOf(f) === i)

  // colorize
  const segs = sleg.map((f,i) => {
    return {
      ...f,
      fill: getMaterialColor(f.type === 'shot' ? entities.indexOf(f.spot) : i)
    }
  })

  // split segs into spots
  const numberSpots = Math.ceil(duration * fps / framesPerSpot)

  const spots = numberSpots && Array.from(Array(numberSpots))
    .map((_, i, a) => {
      // there's a 0.04 second gap between the end of a shot and the beginning of the next
      // an d we've had to fiddle with the duration to round up to the nearest second
      // so just dividing it up wont always work - so apply to the duration then convert back
      const left = i / a.length
      const right = (i + 1) / a.length
      const start = left * duration
      const end = right * duration
      return {
        start,
        end,
        left,
        right
      }
    })
    .map((f) => {

      // another problem is that shot changes won't always nicely fit at spot boundaries
      // but that can't be avoided - in fact it's accuraate but looks funny - so we'll leave that in

      return {
        ...f,
        items: segs.reduce((p, c) => {
          c.segments.forEach(g => {

            if (g.endTime >= f.start && g.startTime <= f.end) {
              const left = g.startTime / duration
              const right = g.endTime / duration
              p.push({
                ...c,
                ...g,
                left: Math.max(f.left, left),
                right: Math.min(f.right, right)
              })
            }
          })
          return p;
        }, [])
          // so we always get the plot in a sensible text order
          .sort((a, b) =>
            a.text > b.text ? 1 : a < b.text ? -1 : 0
          )
      }
    })
    .filter((f) => f.items.length)

  // find the max no of items we'll show
  const maxItems = spots.reduce((p,c)=>Math.max(c.items.length,p),0)

    // work out top and bottom positions
  return {
    duration,
    spots: spots.map(f => {
      return {
        ...f,
        items: f.items.map((g, i) => {
          return {
            ...g,
            top: 1 - i / maxItems,
            bottom: 1 - (i + 1) / maxItems
          }
        })
      }
    })
  }

}

// plot all the segments
export const segPlot = ({ ctx, spots, progress }) => {
  clearCanvas(ctx)
  spots.forEach((f) => {
    f.items.forEach((g) => {
      drawBox(ctx, g, {
        fill: g.fill,
        opacity: progress >= g.right ? opacities.past : opacities.future
      })
    })
  })
}
const pointInBox = ({ box, point }) => {

  return (point.left >= box.left && point.left <= box.right) &&
    (point.top >= box.bottom && point.top <= box.top)
}

// find the spot at a given evt
export const getSpotAtEvt = ({ ctx, evt, spots }) => {
  // get the box from the event

  const point = getNormalizedBox({ ctx, evt })

  // look through the spots for who is there
  return spots.reduce((p, spot) => {
    if (!p) {
      const item = spot.items.find(item => pointInBox({
        box: {
          left: spot.left,
          right: spot.right,
          top: item.top,
          bottom: item.bottom
      }, point}))
      if (item) {
        p = {
          item,
          spot,
          point,
          evt
        }
      }
    }
    return p
  }, null)

}
